import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';

const LABEL_MAP = {
  last_agm_date: 'Last AGM Date',
  last_egm_date: 'Last EGM Date',
  last_committee_date: 'Last Committee Date',
};

const FIELD_ORDER = ['last_agm_date', 'last_egm_date', 'last_committee_date'];

const AssociatedDateFieldsSection = ({ formData, errors, handleInputChange, isDark, isLoading }) => {
  const raw = formData.associated_date_fields || [];
  const fields = [...raw].sort((a, b) => FIELD_ORDER.indexOf(a) - FIELD_ORDER.indexOf(b));
  if (!fields.length) return null;

  return (
    <>
      {fields.map((field) => (
        <div key={field} className={`border-none rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
          isDark ? 'bg-[#000000]' : 'bg-white'
        }`}>
          <span className={`font-medium text-[16px] leading-normal transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>
            {LABEL_MAP[field] || field} <span className="text-[#FF0000]">*</span>
          </span>
          <div className={`border-none rounded-[8px] p-[12px] flex items-center gap-[6px] w-full relative transition-colors duration-200 focus-within:border-solid focus-within:border-[1px] focus-within:border-[#CD6D2C] ${
            errors[field] ? 'border-[1px] border-[#FF0000]' : ''
          } ${
            isDark ? 'bg-[#161515]' : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa]'
          } ${isLoading ? 'opacity-50' : ''}`}>
            <style>{`
              input[type="datetime-local"]::-webkit-calendar-picker-indicator {
                opacity: 0;
                position: absolute;
                right: 0;
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
              input[type="datetime-local"]::-webkit-inner-spin-button,
              input[type="datetime-local"]::-webkit-clear-button {
                display: none;
              }
            `}</style>
            <input
              type="datetime-local"
              value={formData[field] || ''}
              onChange={(e) => handleInputChange(field, e.target.value)}
              disabled={isLoading}
              className={`flex-1 bg-transparent border-0 outline-none text-[16px] pr-[32px] transition-colors duration-200 focus:outline-none ${
                isLoading ? 'cursor-not-allowed' : ''
              } ${
                isDark ? 'text-white placeholder:text-[#b3b3b3]' : 'text-[#686868] placeholder:text-[#686868]'
              }`}
            />
            {isLoading ? (
              <div className="absolute right-[12px] top-1/2 -translate-y-1/2">
                <Loader2 className={`w-[16px] h-[16px] animate-spin ${isDark ? 'text-[#b3b3b3]' : 'text-[#555]'}`} />
              </div>
            ) : (
              <div
                className="absolute right-[12px] top-1/2 transform -translate-y-1/2 w-[16px] h-[16px] pointer-events-none"
                style={{
                  backgroundColor: isDark ? '#b3b3b3' : '#686868',
                  WebkitMaskImage: "url('/assets/icons/calendar.svg')",
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskSize: 'contain',
                  WebkitMaskPosition: 'center',
                  maskImage: "url('/assets/icons/calendar.svg')",
                  maskRepeat: 'no-repeat',
                  maskSize: 'contain',
                  maskPosition: 'center',
                  transition: 'background-color 0.2s ease'
                }}
                aria-hidden="true"
              />
            )}
          </div>
          {errors[field] && (
            <div className="flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
              <AlertCircle className="w-[16px] h-[16px] flex-shrink-0 mt-[1px]" />
              <span className="leading-[1.4]">{LABEL_MAP[field] || field} is required.</span>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default AssociatedDateFieldsSection;
